import { render, staticRenderFns } from "./ConsultDetail.vue?vue&type=template&id=7b456c02&scoped=true&"
import script from "./ConsultDetail.vue?vue&type=script&lang=js&"
export * from "./ConsultDetail.vue?vue&type=script&lang=js&"
import style0 from "./ConsultDetail.vue?vue&type=style&index=0&id=7b456c02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b456c02",
  null
  
)

export default component.exports